export const SingInSignUpBanner = ({ store }: { store: string }) => {
  return (
    <div className="bg-green-600 text-white rounded-md px-4 py-4 my-6 mx-auto max-w-xl shadow-md">
      <div className="flex items-center">
        <img
          src="https://cdn.shopify.com/shopifycloud/brochure/assets/brand-assets/shopify-logo-shopping-bag-monotone-white-7624c6bd631b29ccc947e40d10b4705ee512bc9ec31c7aceb56d9617a04be936.svg"
          alt="Shopify"
          className="w-5 h-5 mr-2 "
        />
        <span className="font-semibold text-sm">Store Detected</span>
      </div>
      <div className="bg-white text-green-900 rounded-md mt-3 p-3 text-sm flex flex-col">
        <span>
          Join your <strong className="truncate">{store}</strong> team!
        </span>
        <span>Log in or sign up below to get started.</span>
      </div>
    </div>
  );
};
